import { render, staticRenderFns } from "./mytaskOR.vue?vue&type=template&id=cdefaa34&scoped=true&"
import script from "./mytaskOR.vue?vue&type=script&lang=js&"
export * from "./mytaskOR.vue?vue&type=script&lang=js&"
import style0 from "./mytaskOR.vue?vue&type=style&index=0&id=cdefaa34&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdefaa34",
  null
  
)

export default component.exports